import React from 'react';

interface PageHeadlineProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  gradientFrom?: string;
  gradientTo?: string;
}

/**
 * Shared page hero/header with gradient background.
 * Use to keep page titles consistent across the app.
 */
const PageHeadline: React.FC<PageHeadlineProps> = ({
  title,
  subtitle,
  actions,
  className = '',
  gradientFrom = 'from-blue-500',
  gradientTo = 'to-blue-700'
}) => {
  return (
    <div
      className={`bg-gradient-to-r ${gradientFrom} ${gradientTo} rounded-xl shadow-lg text-white ${className}`}
      style={{ padding: '1rem 1.5rem' }}
    >
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <div>
          <h1 className="text-xl font-bold leading-tight">{title}</h1>
          {subtitle ? <p className="mt-1 text-sm text-slate-200">{subtitle}</p> : null}
        </div>
        {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
      </div>
    </div>
  );
};

export { PageHeadline };
